import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import NavBar from './components/shared/NavBar';
import Footer from './components/shared/Footer';
import AppRoutes from './routes';
import { Container } from '@mui/material';

function App() {
  return (
    <Router>
      <NavBar />
      <Container component="main" maxWidth="lg">
        <AppRoutes />
      </Container>
      <Footer />
    </Router>
  );
}

export default App;